var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-wrap"},[_c('modal',_vm._b({},'modal',Object.assign({}, {adaptive: true,
    draggable: false,
    resizable: false,
    clickToClose: false,
    width: '90%',
    height: 'auto',
    shiftY: 0.3,
    maxWidth: 800},
    _vm.modalAttrs,
    {name: _vm.modalName}),false),[_vm._t("default"),(_vm.mainButtonText || _vm.secondButtonText)?_c('div',{staticClass:"btn-wrap"},[(_vm.mainButtonText)?_c('button',{staticClass:"main-btn",on:{"click":_vm.mainClick}},[_vm._v(" "+_vm._s(_vm.mainButtonText)+" ")]):_vm._e(),(_vm.secondButtonText)?_c('button',{staticClass:"second-btn",on:{"click":_vm.secondClick}},[_vm._v(" "+_vm._s(_vm.secondButtonText)+" ")]):_vm._e()]):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }